import { parseNumericInput, toAsciiDigits } from './numericInput';
// Public example holdings are fictional; rate calculations require an explicit current quote.
export const DEMO = Object.freeze({
  walletRial: 25000000,
  silverGram: 12.5,
  defaultAmountRial: 10000000,
  goalRial: 150000000,
  transaction: Object.freeze({ id: 'DEMO-001', gram: 2, status: 'pending' }),
});

export function canonicalNumber(value) {
  return toAsciiDigits(value).trim().replace(/٫/g, '.').replace(/[٬,\s]/g, '');
}

export function positiveInput(value, {allowZero = false, maximum = 1000000000000, integer = false} = {}) {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  const parsed = parseNumericInput(String(value).trim());
  if (!parsed.valid || !/^\d+(?:\.\d+)?$/.test(parsed.value)) return null;
  const number = Number(parsed.value);
  if (!Number.isFinite(number) || number > maximum || (integer && !Number.isSafeInteger(number)) || (allowZero ? number < 0 : number <= 0)) return null;
  return number;
}

export function demoConversion(mode, input, priceRialPerGram) {
  if (!Number.isSafeInteger(priceRialPerGram) || priceRialPerGram <= 0) return {valid: false, amountRial: null, gram: null};
  const value = positiveInput(input,{integer:mode==='amount'});
  if (value === null) return {valid: false, amountRial: null, gram: null};
  if (mode === 'amount') return {valid: true, amountRial: value, gram: value / priceRialPerGram};
  const rawRial = value * priceRialPerGram;
  const roundedRial = Math.round(rawRial);
  if (mode === 'weight' && roundedRial > 0 && Number.isSafeInteger(roundedRial) && Math.abs(rawRial-roundedRial) < 0.000001) return {valid: true, gram: value, amountRial: roundedRial};
  return {valid: false, amountRial: null, gram: null};
}

export function contributionPlan(targetInput, contributionInput, currentInput = 0) {
  const target = positiveInput(targetInput,{integer:true});
  const contribution = positiveInput(contributionInput,{integer:true});
  const current = positiveInput(currentInput, {allowZero: true,integer:true});
  if (target === null || contribution === null || current === null) return null;
  const remaining = Math.max(0, target - current);
  return {target, contribution, current, remaining, steps: Math.ceil(remaining / contribution), percent: Math.min(100, current / target * 100)};
}

export function goalBasis({silverGram, walletRial, buyPriceRial}) {
  if (!Number.isSafeInteger(walletRial) || walletRial < 0 || !Number.isFinite(silverGram) || silverGram < 0) return null;
  if (silverGram > 0 && !(Number.isFinite(buyPriceRial) && buyPriceRial > 0)) return null;
  const basis = silverGram === 0 ? walletRial : Math.round(walletRial + silverGram * buyPriceRial);
  return Number.isSafeInteger(basis) ? basis : null;
}

export function nextIllustrativeStep(current, maximum = 6) {
  return Math.min(maximum, Math.max(0, Number(current) || 0) + 1);
}
